import { FiltersTypes, IFiltersAttributes, IFilterSelectOptions, IFiltersGroups } from 'types/filters';
import { LeasesStatuses, TepRelevance } from './tep';
import { AllRoutes } from './routes';

export enum FilterValueType {
  Number,
  Date,
}

export enum FiltersGroups {
  TepLeases = 'tepLeases',
}

export enum FiltersKeys {
  Status = 'status',
  Tep = 'tep',
}

export const FILTER_GROUP_BY_PATH = {
  [AllRoutes.TepManagement]: FiltersGroups.TepLeases,
};

export const FILTER_VALUES_BY_MASK: Record<string, Record<string, string>> = {
  [FiltersKeys.Status]: {
    [LeasesStatuses.Drafted]: 'drafted',
    [LeasesStatuses.Issued]: 'issued',
    [LeasesStatuses.Available]: 'available',
  },
  [FiltersKeys.Tep]: {
    [TepRelevance.Valid]: 'Valid TEP',
    [TepRelevance.Expired]: 'Expired TEP',
  },
};

export const FILTER_SELECT_OPTIONS: IFilterSelectOptions = {
  [FiltersGroups.TepLeases]: {
    [FiltersKeys.Status]: [
      { value: LeasesStatuses.Drafted, label: 'drafted' },
      { value: LeasesStatuses.Issued, label: 'issued' },
      { value: LeasesStatuses.Available, label: 'available' },
    ],
    [FiltersKeys.Tep]: [
      { value: 'valid', label: 'Valid TEP' },
      { value: 'expired', label: 'Expired TEP' },
    ],
  },
};

export const FILTERS_ATTRIBUTES: IFiltersAttributes = {
  [FiltersGroups.TepLeases]: {
    [FiltersKeys.Status]: { label: 'Status', apiParam: 'status' },
    [FiltersKeys.Tep]: { label: 'TEP', apiParam: 'expired' },
  },
};

export const FILTERS_GROUPS: IFiltersGroups = {
  [FiltersGroups.TepLeases]: [
    { label: 'Status', urlKey: FiltersKeys.Status, type: FiltersTypes.Select },
    { label: 'TEP', urlKey: FiltersKeys.Tep, type: FiltersTypes.Select },
  ],
};
